import homeVideoSearchItem from "fragments/homeVideos/homeVideoSearchItem"
import gql from "graphql-tag"

const GET_HOME_VIDEOS = gql`
  ${homeVideoSearchItem}

  query getHomeVideos($query: GetQueryHomeVideos) {
    getHomeVideos(query: $query) {
      ...HomeVideoSearchItem
    }
  }
`

export default GET_HOME_VIDEOS
